/**
 * Pálinka Érlelés módja
 */
export type AgingMethod =
  | 'FRUIT_BED'
  | 'IN_BARRIQUE_BARREL'
  | 'IN_WOODEN_BARREL';

export const AgingMethod = {
  FruitBed: 'FRUIT_BED' as AgingMethod,
  InBarriqueBarrel: 'IN_BARRIQUE_BARREL' as AgingMethod,
  InWoodenBarrel: 'IN_WOODEN_BARREL' as AgingMethod,
};
